supplierForm.$inject = ['$rootScope', 'AppService', 'ServiceService', '$timeout', '$uibModal']

export default function supplierForm($rootScope, AppService, ServiceService, $timeout, $uibModal) {
  var directive = {
    restrict: 'E',
    replace: true,
    scope: {
      supplier: '=',
      activeTab: '='
    },
    link: function(scope, elem, attrs) {
      scope.$parent[attrs.property] = this
      this.isPristine = () => scope.supplierForm.$pristine

      scope.filePath = $rootScope.filePath
      AppService.getMediaPlacements().then(res => scope.mediaPlacements = res.data)
      AppService.getTimeUnits().then(res => scope.timeUnits = res.data)
      ServiceService.getServices(sessionStorage.getItem('profileId')).then(res => scope.services = res.data)

      scope.uploadMedias = function(files, placement, invalidFiles) {
        files.forEach((file, index) => {
          scope.uploadedFile = true
          $rootScope.$on('uploadProgress', (event, data) => scope.uploadProgress = data)

          AppService.uploadMedia(file).then(res => {
            var file = res.data

            scope.uploadProgress = 100.0
            $timeout(function() {
              scope.hideAlert('uploadedFile')
            }, 5000)

            if (!scope.supplier.medias) scope.supplier.medias = new Array()

            var media, originalMedia
            new Promise((resolve, reject) => {
              if (file.type.includes('video')) {
                AppService.getMediaById(file.attrs.mediaId).then(res => {
                  originalMedia = file
                  media = res.data
                  resolve()
                })
              } else {
                media = file
                resolve()
              }
            }).then(() => {
              var existingSupplierToMediasSamePlacement = scope.supplier.medias.filter(media => media.mediaPlacement.placement.toLowerCase() == placement)
              var mediaPlacement = scope.mediaPlacements.find(mediaPlacement => mediaPlacement.placement.toLowerCase() == placement)
              var newSupplierToMediaSamePlacement = {
                order: existingSupplierToMediasSamePlacement.length + 1,
                mediaId: file.id,
                mediaPlacementId: mediaPlacement.id,
                media: media,
                mediaPlacement: mediaPlacement
              }
              if (originalMedia) newSupplierToMediaSamePlacement.originalMedia = originalMedia
              scope.supplier.medias.push(newSupplierToMediaSamePlacement)
              if (existingSupplierToMediasSamePlacement.length === 1 && existingSupplierToMediasSamePlacement[0].mediaPlacement.isReplace) {
                var index = scope.supplier.medias.findIndex(media => media === existingSupplierToMediasSamePlacement[0], 1)
                scope.supplier.medias.splice(index, 1)
                newSupplierToMediaSamePlacement.order = newSupplierToMediaSamePlacement.order - 1
              }
            })
          })
        })
        invalidFiles.forEach((file, index) => {
          scope.invalidFile = true
          scope.file = file
          $timeout(function() {
            scope.hideAlert('invalidFile')
          }, 5000)
        })
      }
      scope.addCommunication = function() {
        if (!scope.supplier.communications) scope.supplier.communications = new Array()
        scope.supplier.communications.push({
          order: scope.supplier.communications.length + 1,
          isPrimary: scope.supplier.communications.length === 0 ? true : false
        })
      }
      scope.deleteCommunication = function(index) {
        scope.supplier.communications.splice(index, 1)
      }
      scope.addSocial = function() {
        if (!scope.supplier.socials) scope.supplier.socials = new Array()
        scope.supplier.socials.push({
          order: scope.supplier.socials.length + 1
        })
      }
      scope.deleteSocial = function(index) {
        scope.supplier.socials.splice(index, 1)
      }
      scope.addExternalResource = function() {
        $uibModal.open({
          controller: 'ModalExternalResourceController',
          controllerAs: 'modalExternalResource',
          template: require('../../app/external-resource-modal-new.html')
        }).result.then(externalResource => {
          if (externalResource) {
            scope.supplier.externalResources.push(externalResource)
          }
        })
      }
      scope.removeMedia = function(media) {
        var index = scope.supplier.medias.findIndex(media2 => media2.id === media.id)
        scope.supplier.medias.splice(index, 1)
      }
      scope.hideAlert = function(alert) {
        scope[alert] = false
      }
    },
    template: require('./_form-supplier.html')
  }

  return directive
}